import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import each from 'lodash/each';
import reduce from 'lodash/reduce';
import every from 'lodash/every';
import flatten from 'lodash/flatten';
import { useMemo } from 'react';

function filterQuerylets(value, indexedQuerylets, indexedForms) {
  const matchIndexList = (list, query) => find(list, (idx) => idx.indexOf(query.toLowerCase()) !== -1);
  const resultsDbFacts = [];
  let resultsForms = [];

  // search indexed facts
  each(indexedQuerylets, (indexed) => {
    const dbItem = indexed._databaseData;
    let foundFacts = reduce(
      indexed._factsIndexes,
      (acc, indexesByPriority, factId) => {
        every(indexesByPriority, (indexes, priority) => {
          if (matchIndexList(indexes, value)) {
            const factItem = indexed._factsData[factId];

            acc[priority] = acc[priority] || [];
            acc[priority].push(factItem);
            return false;
          }

          return true;
        });

        return acc;
      },
      []
    );
    foundFacts = flatten(foundFacts);

    if (!isEmpty(foundFacts)) {
      resultsDbFacts.push({
        ...dbItem,
        children: foundFacts,
        childrenCount: foundFacts.length,
      });
    }
  });

  // search indexed forms - only using highest priority
  resultsForms = reduce(
    indexedForms,
    (acc, indexed) => {
      const formItem = indexed._formData;
      const priorityLevels = Object.keys(indexed._formIndexes);

      if (priorityLevels.length > 0) {
        const highestPriority = priorityLevels.sort()[0];
        const indexes = indexed._formIndexes[highestPriority];

        if (indexes && matchIndexList(indexes, value)) {
          acc.push(formItem);
        }
      }

      return acc;
    },
    []
  );

  return [...resultsDbFacts, ...resultsForms];
}

function useSearchQuerylets(value, indexedQuerylets, indexedForms) {
  return useMemo(() => {
    const shouldSearch = value && value.length > 1;
    return [shouldSearch, shouldSearch ? filterQuerylets(value, indexedQuerylets, indexedForms) : []];
  }, [value, indexedQuerylets, indexedForms]);
}

export default useSearchQuerylets;
